/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useContext } from 'react';
import { AuthContext } from 'store/context';
import { Form, Input, Alert } from 'antd';
import { useNavigate, Link } from 'react-router-dom';
import { hideMessage, registerTenant } from 'store/actions/AuthAction';
import { useWindowSize } from 'react-use';
import classNames from 'classnames';
import { EyeFilled, EyeInvisibleFilled } from '@ant-design/icons';
import { MIN_MD } from 'constants/ThemeSetting';
import OmiButton from 'components/@Omini/OmiButton';
import BranchIntro from 'components/Auth/BranchIntro';

export default function SignUp() {
  const { width } = useWindowSize();
  const navigate = useNavigate();
  const {
    AuthState: { loading, error },
    AuthDispatch,
  } = useContext(AuthContext);

  useEffect(() => {
    AuthDispatch(hideMessage());
  }, [AuthDispatch]);

  const handleSubmit = values => {
    registerTenant({ payload: values, dispatch: AuthDispatch, navigate });
  };
  const formBtnSubmitClasses = classNames({
    'omi-auth-form-submit': true,
    'mt-10 md:mt-16': !error,
  });
  const alertClasses = classNames({
    'omi-auth-alert': true,
    'flex items-center mt-8 md:mt-12': error,
    hidden: !error,
  });
  return (
    <div className="flex flex-col lg:flex-row lg:h-auto">
      <div className="omi-auth-layout-title">
        <BranchIntro isSignup />
      </div>
      <div className="omi-auth-layout-content">
        <div className="flex lg:h-auto flex-col justify-start items-center m-6 mt-0 sm:mx-40 lg:justify-start lg:p-0 lg:pt-24 lg:mb-0">
          <div className="omi-auth-form sign-up-container">
            <p className="omi-auth-form-title">Đăng ký miễn phí</p>
            <p className="mb-6 lg:mb-8">Trải nghiệm sử dụng phần mền trong 14 ngày!</p>
            <Form name="sign-up" size={width >= MIN_MD ? 'large' : 'middle'} layout="vertical" onFinish={handleSubmit}>
              <Form.Item
                name="name"
                label="Tên cửa hàng"
                rules={[
                  {
                    required: true,
                    message: 'Yêu cầu nhập tên cửa hàng.',
                  },
                ]}
              >
                <Input placeholder="Vd: Nhà thuốc Omini" />
              </Form.Item>
              <div className="inline-block w-1/2 pr-2">
                <Form.Item
                  label="Họ"
                  name="last_name"
                  rules={[
                    {
                      required: true,
                      message: 'Yêu cầu nhập họ.',
                    },
                  ]}
                >
                  <Input placeholder="Vd: Nguyễn Văn" />
                </Form.Item>
              </div>
              <div className="inline-block w-1/2 pl-2">
                <Form.Item
                  label="Tên"
                  name="first_name"
                  rules={[
                    {
                      required: true,
                      message: 'Yêu cầu nhập tên.',
                    },
                  ]}
                >
                  <Input placeholder="Vd: A" />
                </Form.Item>
              </div>
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  {
                    type: 'email',
                    message: 'Định dạng email không đúng. Vui lòng kiểm tra lại.',
                  },
                  {
                    required: true,
                    message: 'Yêu cầu nhập email.',
                  },
                ]}
              >
                <Input placeholder="hello@omini.vn" />
              </Form.Item>
              <Form.Item
                name="tel"
                label="Số điện thoại"
                rules={[
                  {
                    required: true,
                    message: 'Yêu cầu nhập số điện thoại.',
                  },
                ]}
              >
                <Input placeholder="Số điện thoại" />
              </Form.Item>
              <Form.Item
                label="Mật khẩu"
                name="password"
                rules={[
                  {
                    required: true,
                    message: 'Yêu cầu nhập mật khẩu.',
                  },
                ]}
              >
                <Input.Password
                  iconRender={visible =>
                    visible ? <EyeFilled width={18} height={18} /> : <EyeInvisibleFilled width={18} height={18} />
                  }
                  placeholder="Mật khẩu"
                />
              </Form.Item>
              <Form.Item className={formBtnSubmitClasses}>
                <Alert className={alertClasses} message={error} type="error" showIcon />
                <OmiButton type="primary" className="omi-auth-button" htmlType="submit" block loading={loading}>
                  Tạo tài khoản miễn phí
                </OmiButton>
              </Form.Item>
              <div className="flex justify-end mt-4">
                <Link to="/login" className="f-semibold text-grey-700 text-xs sm:text-sm sm:mb-8">
                  Trở về đăng nhập
                </Link>
              </div>
              <p className="hidden sm:block text-center mb-12">
                Khi nhấn vào nút &quot;Tạo tài khoản miễn phí&quot; đồng nghĩa với việc bạn đã đồng ý các{' '}
                <Link to="#" className="text-blue-600">
                  điều khoản
                </Link>{' '}
                và{' '}
                <Link to="#" className="text-blue-600">
                  chính sách
                </Link>{' '}
                của Omini
              </p>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}
